import MulaiInvestasiBenefits from './Benefits';
import ComparisonGraph from './ComparisonGraph';
import MulaiInvestasiFeatures from './Features';
import MulaiInvestasiHeader from './Header';
import MulaiInvestasiKomisi from './Komisi';
import MulaiInvestasiSteps from './Steps';
import { Container } from './styled';

const MulaiInvestasiFeature = () => (
  <Container>
    <MulaiInvestasiHeader />
    <MulaiInvestasiSteps />
    <MulaiInvestasiKomisi />
    <ComparisonGraph />
    <MulaiInvestasiBenefits />
    <MulaiInvestasiFeatures />
  </Container>
);

export default MulaiInvestasiFeature;
